import { domain } from '@framework/config/domain';
import env from '@framework/env/env';

const config = {
  name: 'Deal Roadshow',
  code: 'dealroadshow' as const,
  abbr: 'DRS',
  supportEmail: env('CREDENTIALS__DEAL_ROADSHOW__SUPPORT__EMAIL'),
  supportPhoneNumber: env('CREDENTIALS__DEAL_ROADSHOW__SUPPORT__PHONE'),
  hostname: `${ domain.dealroadshowDomain }`,
  ga: {
    trackingId: env('GA__TRACKING_ID_DEALROADSHOW'),
  },
  gtm: {
    trackingId: env('FRONTEND___GOOGLE_TAG_MANAGER__TENANT_DEALROADSHOW__GTM_ID'),
  },
  isConsentForEDeliveryRequired: false,
  supportChatId: env('FRONT_APP__CHAT_ID_TENANT_DEALROADSHOW'),
  presentation: {
    changeSlide: {
      debounce: 200,
    },
    prefetchSlides: {
      debounce: 150,
      amount: 7,
    },
    idleTime: 8 * 60 * 1000, // 8m in ms
    idleLogoutTime: 30 * 60 * 1000, // 30m in ms
    maxIdleTime: 3 * 60 * 60 * 1000, // 3h in ms
  },
  featureToggle: {},
};

export default config;
